import gateway from '../gateway/gateway'

// Actions
const SET_REQUIRED_FIELDS = 'SET_REQUIRED_FIELDS'

export default function reducer(state = [], { type, requiredFields }) {
  switch (type) {
    case SET_REQUIRED_FIELDS:
      return [...requiredFields]
    default:
      return state
  }
}

// Action creators
export function setRequiredFields(requiredFields) {
  return {
    type: SET_REQUIRED_FIELDS,
    requiredFields,
  }
}

export const getRequiredFields = () => dispatch =>
  gateway.requiredFields.getRequiredFields().then(data => {
    dispatch(setRequiredFields(data || []))
  })
